import {Logger} from 'aws-amplify'

export const logger = new Logger('stock-management')
